module.exports = __webpack_public_path__ + "img/2.4fabac9b.png";